import { Component, Input, HostListener, ElementRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
@Component({
  selector: 'app-file-upload',
  templateUrl: 'file-uploader.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: FileUploadComponent,
      multi: true
    }
  ]
})
export class FileUploadComponent implements ControlValueAccessor {
  @Input() progress;
  @Input() set showModal (show:boolean) {
    if(show) this.writeValue(null);
  };
  onChange: Function;
  private file: File | null = null;

  @HostListener('change', ['$event']) emitFiles(event) {
    let eventFile: FileList = event.target.files;
    let file = eventFile && eventFile.item(0);
    if(file) this.onChange(file);
    else {
      this.onChange(null);
      file = null;
    }
    this.file = file;
  }

  constructor( private host: ElementRef ) {
  }

  writeValue( value: null ) {
    // clear file input
    this.host.nativeElement.value = '';
    this.file = null;
  }

  registerOnChange( fn: Function ) {
    this.onChange = fn;
  }

  registerOnTouched( fn: Function ) {
  }

}


// WEBPACK FOOTER //
// ./src/app/containers/fwdr/detail/file-uploader.ts